<footer id="footer" class="footer">
  <div class="footer-content-container">
    <div class="hub-stack">
      <app-be-logo-v2 [isLink]="false" class="logo-icon"></app-be-logo-v2>
      @if (showPayoffDisclosures) {
        <p class="disclosure-text">
          Payoff amount includes your principal balance, unpaid accrued interest
          and any applicable outstanding fees. Quotes are accurate when given,
          however the payoff amount is subject to change daily.
        </p>
        <p class="disclosure-text">
          All quotes as of {{ quoteAsOfDate | async }}. If you have any
          questions or concerns please call 855-282-6353.
        </p>
      }
      <p class="disclosure-text">
        &copy; {{ currentYear }} Marlette Marketing, LLC. All rights reserved
      </p>
    </div>
    @for (stack of mainFooterStacks; track stack) {
      <nav
        class="footer-stack"
        [attr.aria-labelledby]="stack.id"
        >
        <h2 class="stack-heading" [id]="stack.id">{{ stack.heading }}</h2>
        <ul class="nav">
          @for (item of stack.items; track item) {
            <li class="nav-item">
              @if (item.url) {
                <a
                  class="nav-link"
                  [href]="item.url"
                  target="_blank"
                  >
                  {{ item.label }}
                </a>
              }
            </li>
          }
        </ul>
      </nav>
    }

    <div class="footer-stack flex flex-col gap-7">
      @if (displayMobileCard()) {
        <section class="mobile-app-section">
          <h2 class="be-eyebrow-text stack-heading tw-mb-2" id="footerMobileApp">
            Mobile App
          </h2>
          <app-app-store-links
            [isDarkMode]="true"
            [isFooter]="true"
          ></app-app-store-links>
        </section>
      }
      <nav class="" [attr.aria-labelledby]="pressFooterStack.id">
        <h2 class="stack-heading" [id]="pressFooterStack.id">
          {{ pressFooterStack.heading }}
        </h2>
        <ul class="nav">
          <li class="nav-item">
            <ul class="nav nav--social-media">
              <li>
                <a
                  class="footer-icon"
                  href="https://www.facebook.com/mybestegg"
                  target="_blank"
                  aria-label="Visit us on Facebook"
                  >
                  <svg
                    width="10"
                    height="21"
                    viewBox="0 0 10 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M9.34685 11.9441L9.86487 8.35211H6.62162V6.01974C6.62162 5.03794 7.07658 4.08008 8.52703 4.08008H10V1.02453C10 1.02453 8.66216 0.780273 7.38288 0.780273C4.71171 0.780273 2.96847 2.49962 2.96847 5.61265V8.35211H0V11.9441H2.96847V20.627C3.56306 20.7276 4.17117 20.7803 4.79279 20.7803C5.41441 20.7803 6.02252 20.7276 6.61712 20.627V11.9441H9.34234H9.34685Z"
                      fill="white"
                      />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="footer-icon"
                  href="https://www.linkedin.com/company/bestegg"
                  target="_blank"
                  aria-label="Visit us on Linked In"
                  >
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M4.5277 20.7803H0.395778V7.44518H4.5277V20.7803ZM2.44327 5.69848C1.09235 5.69848 0 4.59558 0 3.23938C0 1.88318 1.09235 0.780273 2.44327 0.780273C3.79419 0.780273 4.88654 1.88318 4.88654 3.23938C4.88654 4.59558 3.79419 5.69848 2.44327 5.69848ZM20 20.7803H15.8892V13.7829C15.8892 11.8621 15.1609 10.7908 13.6412 10.7908C11.9894 10.7908 11.124 11.9043 11.124 13.7829V20.7803H7.16095V7.44518H11.124V9.23938C11.124 9.23938 12.3166 7.03357 15.1451 7.03357C17.9736 7.03357 20 8.75917 20 12.3317V20.775V20.7803Z"
                      fill="white"
                      />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="footer-icon"
                  href="https://www.instagram.com/mybestegg/"
                  target="_blank"
                  aria-label="Visit us on Instagram"
                  >
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M10 0.780273C7.28636 0.780273 6.94153 0.790268 5.87706 0.840243C4.81259 0.890218 4.08796 1.05514 3.44828 1.30501C2.78861 1.55988 2.23388 1.89971 1.67916 2.45943C1.12444 3.01416 0.77961 3.57388 0.524738 4.22855C0.274863 4.86323 0.109945 5.59287 0.0599704 6.65734C0.00999542 7.7218 0 8.06663 0 10.7803C0 13.4939 0.00999542 13.8337 0.0599704 14.9032C0.109945 15.9677 0.27986 16.6923 0.524738 17.332C0.77961 17.9917 1.12444 18.5464 1.67916 19.1011C2.23388 19.6558 2.7936 20.0007 3.44828 20.2555C4.08296 20.5004 4.81259 20.6703 5.87706 20.7203C6.94153 20.7703 7.28636 20.7803 10 20.7803C12.7136 20.7803 13.0535 20.7703 14.1229 20.7203C15.1874 20.6703 15.917 20.5054 16.5517 20.2555C17.2114 20.0007 17.7661 19.6558 18.3208 19.1011C18.8756 18.5464 19.2204 17.9867 19.4753 17.332C19.7201 16.6973 19.8901 15.9677 19.94 14.9032C19.99 13.8387 20 13.4989 20 10.7803C20 8.06163 19.985 7.7218 19.94 6.65734C19.8901 5.59287 19.7201 4.86823 19.4753 4.22855C19.2204 3.56888 18.8756 3.01416 18.3208 2.45943C17.7661 1.90471 17.2064 1.55988 16.5517 1.30501C15.912 1.06013 15.1874 0.890218 14.1229 0.840243C13.0585 0.790268 12.7186 0.780273 10 0.780273ZM9.10545 2.58437C9.37032 2.58437 9.67017 2.58437 10 2.58437C12.6687 2.58437 12.9885 2.59437 14.043 2.64434C15.0175 2.68932 15.5472 2.85424 15.902 2.98917C16.3668 3.16908 16.7017 3.38897 17.0515 3.73879C17.4013 4.08862 17.6162 4.42345 17.8011 4.88822C17.936 5.23804 18.101 5.76778 18.1459 6.74229C18.1959 7.79677 18.2059 8.11161 18.2059 10.7803C18.2059 13.4489 18.1959 13.7638 18.1459 14.8183C18.101 15.7928 17.936 16.3225 17.8011 16.6723C17.6212 17.1371 17.4013 17.4719 17.0515 17.8218C16.7017 18.1716 16.3668 18.3865 15.902 18.5714C15.5522 18.7113 15.0225 18.8712 14.043 18.9162C12.9885 18.9662 12.6737 18.9762 10 18.9762C7.32634 18.9762 7.01149 18.9662 5.95702 18.9162C4.98251 18.8712 4.45277 18.7063 4.09795 18.5714C3.63318 18.3915 3.29835 18.1716 2.94853 17.8218C2.5987 17.4719 2.38381 17.1371 2.1989 16.6723C2.06397 16.3225 1.89905 15.7928 1.85407 14.8183C1.8041 13.7638 1.7941 13.4489 1.7941 10.7753C1.7941 8.10161 1.8041 7.79177 1.85407 6.7373C1.89905 5.76278 2.06397 5.23305 2.1989 4.87822C2.37881 4.41346 2.5987 4.07862 2.94853 3.7288C3.29835 3.37897 3.63318 3.16408 4.09795 2.97917C4.45277 2.83924 4.97751 2.67932 5.95702 2.63435C6.88156 2.59437 7.23638 2.57937 9.10045 2.57937L9.10545 2.58437ZM15.3423 4.24854C14.6777 4.24854 14.1429 4.78327 14.1429 5.44794C14.1429 6.11261 14.6827 6.64734 15.3423 6.64734C16.002 6.64734 16.5417 6.10761 16.5417 5.44794C16.5417 4.78827 16.002 4.24854 15.3423 4.24854ZM10.005 5.65284C7.17141 5.65284 4.86757 7.95169 4.86757 10.7903C4.86757 13.6289 7.16642 15.9227 10.005 15.9227C12.8386 15.9227 15.1374 13.6239 15.1374 10.7903C15.1374 7.95669 12.8386 5.65284 10.005 5.65284ZM10.005 7.45693C11.8441 7.45693 13.3383 8.95119 13.3383 10.7903C13.3383 12.6294 11.8441 14.1236 10.005 14.1236C8.16592 14.1236 6.67166 12.6294 6.67166 10.7903C6.67166 8.95119 8.16592 7.45693 10.005 7.45693Z"
                      fill="white"
                      />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="footer-icon"
                  href="https://twitter.com/mybestegg"
                  target="_blank"
                  aria-label="Visit us on Twitter"
                  >
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M15.7282 0.613281H18.7938L12.0627 8.27995L19.9268 18.6799H13.7555L8.92376 12.3599L3.39227 18.6799H0.326625L7.45758 10.4799L-0.0732422 0.613281H6.25132L10.6165 6.38661L15.7282 0.613281ZM14.6552 16.8799H16.3546L5.35828 2.34661H3.53222L14.6552 16.8799Z"
                      fill="white"
                      />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="footer-icon"
                  href="https://www.youtube.com/c/BestEggPlatform"
                  target="_blank"
                  aria-label="Visit us on Youtube"
                  >
                  <svg
                    width="20"
                    height="14"
                    viewBox="0 0 20 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M10.4437 13.7552L6.34085 13.6825C5.01158 13.6553 3.6823 13.7098 2.37602 13.4418C0.393603 13.042 0.255616 11.0842 0.108429 9.43979C-0.093952 7.12763 -0.015759 4.77458 0.366006 2.48059C0.582186 1.19505 1.42851 0.427353 2.74399 0.345587C7.17338 0.0412353 11.635 0.0775763 16.0506 0.218396C16.5151 0.232023 16.9889 0.300161 17.4488 0.381927C19.721 0.77713 19.7762 2.99844 19.9234 4.86543C20.0706 6.75514 20.0062 8.65393 19.7256 10.53C19.5002 12.0836 19.0679 13.3873 17.251 13.5099C14.9743 13.6735 12.7481 13.8052 10.4621 13.7643C10.4621 13.7552 10.4483 13.7552 10.4437 13.7552ZM8.0335 9.82136C9.74914 8.84925 11.4326 7.89077 13.1436 6.92321C11.4234 5.9511 9.74454 4.99262 8.0335 4.02506V9.82136Z"
                      fill="white"
                      />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="footer-icon"
                  href="https://www.tiktok.com/@mybestegg"
                  target="_blank"
                  aria-label="Visit us on TikTok"
                  >
                  <svg
                    width="19"
                    height="21"
                    viewBox="0 0 19 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.3077 0.780273C13.6409 3.61981 15.2478 5.30804 18.0354 5.49186V8.68452C16.4187 8.83932 15.0028 8.31688 13.3567 7.3349V13.3042C13.3567 20.8892 4.984 23.2547 1.61826 17.8223C-0.547174 14.3249 0.780504 8.18628 7.71774 7.93957V11.3064C7.18863 11.3886 6.62523 11.5241 6.10591 11.6982C4.56267 12.2158 3.68572 13.1784 3.93068 14.886C4.3961 18.1512 10.4613 19.1139 9.95667 12.7382V0.785111H13.3028L13.3077 0.780273Z"
                      fill="white"
                      />
                  </svg>
                </a>
              </li>
            </ul>
          </li>
          @for (item of pressFooterStack.items; track item) {
            <li class="nav-item">
              @if (item.url) {
                <a
                  class="nav-link"
                  [href]="item.url"
                  target="_blank"
                  >
                  {{ item.label }}
                </a>
              }
            </li>
          }
        </ul>
      </nav>
    </div>
  </div>
</footer>
